import validator from "validator";
import message from "../../../messages/permisson";

const validateName = (name) => {
  if (validator.isEmpty(name)) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  if (!name.trim().length) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validatePersianName = (persianName) => {
  if (validator.isEmpty(persianName)) {
    return message.PERSIAN_NAME_DOSE_NOT_EXIST;
  }

  if (!persianName.trim().length) {
    return message.PERSIAN_NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validateFormPermisson = (info) => {
  const resValidateName = validateName(info.name);
  if (resValidateName != true) {
    return resValidateName;
  }

  const resValidatePersianName = validatePersianName(info.persian_name);
  if (resValidatePersianName != true) {
    return resValidatePersianName;
  }

  return true;
};

export default validateFormPermisson;
